import { render, staticRenderFns } from "./version.vue?vue&type=template&id=36371954&scoped=true&"
import script from "./version.vue?vue&type=script&lang=js&"
export * from "./version.vue?vue&type=script&lang=js&"
import style0 from "./version.vue?vue&type=style&index=0&id=36371954&prod&lang=scss&"
import style1 from "./version.vue?vue&type=style&index=1&id=36371954&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36371954",
  null
  
)

export default component.exports